export default {
      id: "suppliers-menu-usage",
      viewBox: "0 0 25.585 27.37",
      url: "/dist/svg/" + "sprite.svg#suppliers-menu-usage",
      toString: function () {
        return this.url;
      }
    }